export const getPermissions = () => {
  try {
    return JSON.parse(localStorage.getItem("permissions")) || [];
  } catch {
    return [];
  }
};

export const hasPermission = (perm) => {
  const permissions = getPermissions();
  return permissions.includes(perm);
};

/** Staff session gate for audited mobile reveal (explicit user action only). */
export const canRevealMobileNumber = () => {
  const token = sessionStorage.getItem("token");
  let perms = [];
  try {
    perms = JSON.parse(localStorage.getItem("permissions")) || [];
  } catch {
    perms = [];
  }
  let userData = null;
  try {
    userData = JSON.parse(localStorage.getItem("user_data")) || null;
  } catch {
    userData = null;
  }
  return Boolean(
    token &&
      (perms.length > 0 ||
        userData?.is_staff ||
        userData?.is_admin ||
        userData?.is_superuser)
  );
};
